import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WorkflowNotificationService } from './modules/services/workflow-notification.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Vending Management System';

  constructor(private readonly workflowNotificationService: WorkflowNotificationService) {
    this.workflowNotificationService.connect();
  }
}
